// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1taLV","index":"styles_index__g_-oQ"};